// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__78JZp","filesListContainer":"PosDisputesFiles_filesListContainer__1z-mZ","filesButton":"PosDisputesFiles_filesButton__3Wr8L"};